import { render } from "./Unit2-3.vue?vue&type=template&id=38882791&scoped=true"
import script from "./Unit2-3.vue?vue&type=script&lang=js"
export * from "./Unit2-3.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit2-3.css?vue&type=style&index=1&id=38882791&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38882791"]])

export default __exports__